<template>
  <div class="addOns__card h-100">
    <v-row no-gutters justify="space-between" class="mb-7">
      <h2>Add-Ons</h2>
      <x-button
        v-if="canManage"
        color="primary"
        buttonText="Change Add-Ons"
        class="pa-1 upgrade-btn"
        @click="openDialog"
        :outline="true"
        :data-test-id="`${dataTestId}__change-add-ons-btn`"
      />
    </v-row>
    <div v-if="addOns.length">
      <div v-for="(addOn, index) in addOns" :key="index">
        <AddOnComponent
          v-if="isDataReady"
          :addOn="addOn"
          :available="available"
        />
      </div>
    </div>
    <v-skeleton-loader
      v-else
      class="payment-card mr-2 mb-2"
      min-width="250"
      type="card-heading, list-item-three-line"
    ></v-skeleton-loader>
  </div>
</template>
<script>
import AddOnComponent from './AddOnComponent';
export default {
  name: 'AddOnsCard',
  props: ['canManage', 'addOns', 'available', 'isOrgOnboarded', 'dataTestId'],
  components: { AddOnComponent },
  methods: {
    openDialog() {
      if (this.isOrgOnboarded) {
        this.$emit('openDialog', true);
      } else {
        this.snackbar(
          'info',
          this.$message.ACTION_RESTRICTION_WHILE_ONBOARDING
        );
      }
    }
  },
  computed: {
    isDataReady() {
      return (
        this.addOns.length && this.available.storage && this.available.projects
      );
    }
  }
};
</script>
<style scoped>
.upgrade-btn {
  font-size: 12px;
  width: 124px !important;
}
.addOns__card {
  width: 90%;
}
</style>
